<script>
import async from "async";
import config from "../../libs/config.json";
import { mapGetters, mapActions } from "vuex";
import _system from "../../libs/system";

export default {
  name: "automationRules",
  data() {
    return {
      keywords: "",
      automationRules: [],
      show: {
        channels: false,
        tags: false,
      },
      loading: {
        setRules: false,
      },
      selectedTag: {},
      channels: [],
      channelsList: [],
      selectedChannels: [],
      defaultTag: true,
      test: [],
    };
  },
  computed: {
    ...mapGetters("session", ["getUser"]),
    ...mapGetters("tags", ["tags", "tagsById", "tagsByTypeName", "tagsByName"]),
    ...mapGetters("accounts", ["accounts", "accountsById"]),
    ...mapGetters("networks", ["networksById"]),
    ...mapGetters("workspaces", ["currentWorkspace"]),
    activeAccounts() {
      let onlyActivePages = _.filter(this.accounts, (account) => {
        if (
          (account.tags &&
            account.platform &&
            account.tags.indexOf(this.tagsByName["Passive"]._id) == -1) ||
          !account.tags
        )
          return account;
      });
      return onlyActivePages;
    },
    automatedRules() {
      console.log(this.currentWorkspace.tagKeywords);
      //START set Colors
      let groupedByTag = _.groupBy(this.currentWorkspace.tagKeywords, "tag");
      console.log("grouped", groupedByTag);
      let newTest = _.map(groupedByTag, (rule) => {
        let color = "hsl(" + Math.random() * 360 + ", 100%, 75%)";

        let newArr = [];
        for (let childRule of rule) {
          childRule.color = color;
          newArr.push(childRule);
        }

        return newArr;
      });

      console.log("renk", newTest);

      let coloredRules = _.flatMap(newTest);
      //END set Colors

      let groupedByChannel = _.groupBy(coloredRules, "page");

      console.log("GroupedBy Channel,", groupedByChannel);

      let rulesTest = _.map(groupedByChannel, (rules, key) => {
        let object = {};

        object.channel = this.accountsById[key];

        object.rules = [];

        for (const rule of rules) {
          if (rule.tag && this.tagsById[rule.tag]) {
            rule.tagObject = this.tagsById[rule.tag];
          } else {
            rule.tagObject = _.find(this.currentWorkspace.userTags, {
              _id: rule.tag,
            });
          }

          if (rule.tagObject) {
            object.rules.push(rule);
          }
        }
        console.log("object 2", object);
        //console.log('object 1', object);
        if (object.channel) {
          return object;
        }
      });

      rulesTest = _.filter(rulesTest, (rule) => rule);

      console.log("rulesTest ", rulesTest);

      return rulesTest;
    },
  },
  methods: {
    ...mapActions("session", ["setUser"]),
    ...mapActions("htmlModals", ["setAutomationRulesModal", "setCreateTag"]),
    removeDublicate(arr) {
      return _.uniqBy(arr, "tag");
    },
    setTag(tag) {
      this.selectedTag = tag;
      this.show.tags = false;
      this.defaultTag = false;
    },
    setPlatformImg(account) {
      let fileName = "";
      let mainPath = "/img/socialSvg/";

      // Facebook
      if (this.networksById[account.platform].name == "Facebook")
        fileName = "facebook";

      // Instagram
      if (this.networksById[account.platform].name == "Instagram")
        fileName = "instagram";

      // Twitter
      if (this.networksById[account.platform].name == "Twitter")
        fileName = "twitter";

      // Youtube
      if (this.networksById[account.platform].name == "Youtube")
        fileName = "youtube";

      return mainPath + fileName + ".svg";
    },
    setChannel(channel) {
      this.selectedChannels.push(channel);
      this.channelsList = _.reject(this.channelsList, { _id: channel._id });
    },
    unSetChannel(channel) {
      this.channelsList.unshift(channel);
      this.selectedChannels = _.reject(this.selectedChannels, {
        _id: channel._id,
      });
    },
    removeRule(tag) {
      let payload = {
        query: {
          workspaceId: this.currentWorkspace._id,
          tagKeywordsId: tag._id,
        },
      };

      _system.services.automationRules.remove(payload, (err, res) => {
        if (err) return alert(err.message);

        this.currentWorkspace.tagKeywords = res.tagKeywords;
      });
    },
    saveRule() {
      this.loading.setRules = true;

      let keywordsArray = this.keywords.split(",");
      // filtering out duplicate keywords
      let results = _.forEach(this.selectedChannels, (channel) => {
        let uniqueKeywords = new Set();

        let tagKeywords = _.map(keywordsArray, (keyword) => {
          let trimmedKeyword = keyword.trim();

          if (!uniqueKeywords.has(trimmedKeyword)) {
            uniqueKeywords.add(trimmedKeyword);
            return {
              tag: this.selectedTag._id,
              page: channel._id,
              text: trimmedKeyword,
            };
          }
        }).filter((keyword) => keyword !== undefined);

        channel.tagKeywords = tagKeywords;
        return channel;
      });

      let tagKeywords = [];
      for (let channel of results) {
        for (let tagKeyword of channel.tagKeywords) {
          tagKeywords.push(tagKeyword);
        }
      }
      let noDuplicate = this.currentWorkspace.tagKeywords.some(
        (obj) =>
          obj.page === tagKeywords[0].page &&
          obj.text === tagKeywords[0].text &&
          obj.tag === tagKeywords[0].tag
      );

      if (
        this.currentWorkspace.tagKeywords &&
        this.currentWorkspace.tagKeywords.length
      ) {
        if (noDuplicate) {
          this.loading.setRules = false;
          return alert("Cannot add duplicate keywords with the same tags.");
        } else {
          tagKeywords = tagKeywords.concat(this.currentWorkspace.tagKeywords);
        }
      }
      let payload = {
        query: {
          workspaceId: this.currentWorkspace._id,
        },
        body: {
          tagKeywords: tagKeywords,
        },
      };

      _system.services.automationRules.set(payload, (err, res) => {
        if (err) return alert(err.message);

        this.currentWorkspace.tagKeywords = res.tagKeywords;

        this.loading.setRules = false;

        this.channelsList = this.channels;
        this.loading.setRules = false;
        this.selectedChannels = [];
        this.keywords = "";
        this.selectedTag = {};
      });
    },
  },
  created() {
    Object.assign(this.channels, this.activeAccounts);
    Object.assign(this.channelsList, this.activeAccounts);

    window.analytics.track("Automation Rules Opened");
  },
};
</script>

<template>
  <div class="modalWrapper">
    <div @click="setAutomationRulesModal(false)" class="modal"></div>
    <div class="ui grid">
      <div style="padding-right: 0" class="ten wide column centered">
        <div
          @click="setAutomationRulesModal(false)"
          style="padding-right: 0; padding-bottom: 0; z-index: 9999999"
          class="ui basic segment right aligned"
        >
          <a style="background: rgba(0, 0, 0, 0.6)" class="ui black mini button"
            >Close</a
          >
        </div>
      </div>
    </div>

    <!--   Main Wrapper   -->
    <div class="ui grid">
      <div
        class="ten wide column centered"
        style="z-index: 9999; background: #ffffff; border-radius: 7px"
      >
        <div class="ui basic large segment">
          <h3>Automation Rules</h3>
          <b>Firstly,</b> select channel(s) that you want to set rule(s):
          <div style="display: block; margin: 10px 0px">
            <div style="display: inline-block">
              <div
                v-for="channel in selectedChannels"
                :key="channel._id"
                style="margin: 6px 5px; background: transparent"
                class="ui image small label"
              >
                <img
                  :src="setPlatformImg(channel)"
                  id="imgOn"
                  style="
                    bottom: -8px;
                    width: 14px;
                    height: 14px;
                    border-radius: 20px;
                    vertical-align: middle;
                    position: relative;
                    margin-right: -5px;
                    border: 1px solid #fff;
                  "
                  alt=""
                />
                <img style="border-radius: 50px" :src="channel.avatar" />
                {{ channel.name }}
                <i @click="unSetChannel(channel)" class="delete icon"></i>
              </div>

              <div
                style="
                  border-bottom: 1px dashed #ddd;
                  padding: 5px 12px;
                  border-radius: 3px;
                "
                @click.self="
                  show.channels
                    ? (show.channels = false)
                    : (show.channels = true)
                "
                class="ui floating dropdown"
              >
                <b
                  @click.self="
                    show.channels
                      ? (show.channels = false)
                      : (show.channels = true)
                  "
                  >Select Channel</b
                ><i
                  @click.self="
                    show.channels
                      ? (show.channels = false)
                      : (show.channels = true)
                  "
                  class="dropdown icon"
                ></i>

                <div
                  :style="{ display: show.channels ? 'block' : 'none' }"
                  @mouseleave="show.channels = false"
                  class="icon menu"
                >
                  <div class="divider" style="margin: 0"></div>
                  <div
                    v-for="channel in channelsList"
                    :key="channel._id"
                    @click.self="setChannel(channel)"
                    class="item"
                  >
                    <img
                      :src="setPlatformImg(channel)"
                      style="
                        bottom: 10px;
                        width: 14px;
                        height: 14px;
                        border-radius: 20px;
                        vertical-align: middle;
                        position: absolute;
                        left: 10px;
                        border: 1px solid #fff;
                      "
                      alt=""
                    />
                    <img
                      style="
                        width: 22px;
                        margin-right: 4px;
                        border-radius: 6px;
                        vertical-align: middle;
                      "
                      :src="channel.avatar"
                    />
                    {{ channel.name }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <b>If</b> incoming messages on selected channels, contain keywords
          that defined below:

          <!--           <input v-model="keywords" class="inputContain" style="min-width:100px;" placeholder="price, color, how much" type="text">  -->

          <textarea
            style="
              display: block;
              width: 100%;
              margin: 9px 0px 0px 0px;
              padding: 10px 15px;
              border: 1px solid #ddd
            "
            placeholder="price, color, how much etc."
            v-model="keywords"
            rows="1"
          ></textarea>

          <b>then</b> automatically flag / tag as

          <div
            style="
              margin: 0 10px;
              position: relative;
              display: inline-block;
              border-bottom: 1px dashed #ddd;
              padding: 5px 12px;
              border-radius: 3px;
            "
            class="ui floating dropdown"
          >
            <b
              v-if="!selectedTag.name"
              @click="show.tags ? (show.tags = false) : (show.tags = true)"
              >Select Tag</b
            ><b
              v-if="selectedTag.name"
              @click="show.tags ? (show.tags = false) : (show.tags = true)"
              >{{ selectedTag.name }}</b
            ><i
              @click="show.tags ? (show.tags = false) : (show.tags = true)"
              class="dropdown icon"
            ></i>
            <div
              :style="{ display: show.tags ? 'block' : 'none' }"
              class="icon menu"
            >
              <div
                class="menu-content"
                style="max-height: 250px; overflow: auto"
              >
                <div
                  v-for="tag in tagsByTypeName['DefaultMessageTag']"
                  :key="tag._id"
                  @click.self="setTag(tag)"
                  class="item"
                >
                  {{ tag.name }}
                </div>
                <div
                  v-for="tag in currentWorkspace.userTags"
                  :key="tag._id"
                  @click.self="setTag(tag)"
                  class="item"
                >
                  {{ tag.name }}
                </div>
              </div>
              <div class="divider" style="margin: 0"></div>
              <div
                @click="setCreateTag(true)"
                class="item"
                style="font-weight: bold; position: sticky"
              >
                Create New Tag
              </div>
            </div>
          </div>

          <button
            :disabled="keywords.length && !defaultTag ? false : true"
            :style="
              keywords.length && !defaultTag ? '' : 'background: transparent'
            "
            :class="{
              green: keywords.length && !defaultTag ? true : false,
              loading: loading.setRules ? true : false,
            }"
            @click.self="saveRule()"
            class="ui icon button"
          >
            Set <i class="long arrow alternate right icon"></i>
          </button>
        </div>

        <div
          style="
            margin: -1rem;
            padding: 2rem;
            background: #f9f9f9;
            border-radius: 0 0 7px 7px;
          "
          class="ui basic segment"
        >
          <h3>Automated Rules</h3>
          <div
            v-if="!automatedRules.length"
            style="color: #aaa"
            class="ui basic segment"
          >
            Not found any automated rules.
          </div>
          <table v-if="automatedRules.length" class="ui fluid celled table">
            <thead>
              <tr>
                <th>If messages contain keywords</th>
                <th style="min-width: 100px; text-align: center">
                  Then move into
                </th>
                <th>For channels</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="rule in automatedRules" :key="rule._id">
                <td>
                  <h4 class="ui image header">
                    <div class="content">
                      <div
                        v-for="childRule in rule.rules"
                        :key="childRule._id"
                        style="margin-bottom: 10px"
                        class="ui label"
                        :style="{ background: childRule.color }"
                      >
                        {{ childRule.text }}
                        <i
                          @click="removeRule(childRule)"
                          class="delete icon"
                        ></i>
                      </div>
                    </div>
                  </h4>
                </td>
                <td>
                  <div
                    v-for="childRule in removeDublicate(rule.rules)"
                    :key="childRule._id"
                    style="margin-bottom: 5px"
                    :style="{ background: childRule.color }"
                    class="ui small label"
                  >
                    {{ childRule.tagObject.name }}
                  </div>
                </td>
                <td>
                  <img
                    :src="setPlatformImg(rule.channel)"
                    style="
                      bottom: -8px;
                      width: 14px;
                      height: 14px;
                      border-radius: 20px;
                      vertical-align: middle;
                      position: relative;
                      margin-right: -10px;
                      border: 1px solid #fff;
                    "
                    alt=""
                  />
                  <img
                    style="
                      width: 22px;
                      margin-right: 4px;
                      border-radius: 6px;
                      vertical-align: middle;
                    "
                    :src="rule.channel.avatar"
                  />
                  {{ rule.channel.name }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.menu-content > .item {
  position: relative;
  cursor: pointer;
  display: block;
  border: none;
  height: auto;
  text-align: left;
  line-height: 1em;
  padding: 0.78571429rem 1.14285714rem !important;
  font-size: 1rem;
  text-transform: none;
  font-weight: 400;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-touch-callout: none;
}
.menu-content > .item:hover {
  background: rgba(0, 0, 0, 0.05);
  color: rgba(0, 0, 0, 0.95);
  z-index: 13;
}

#imgOn {
  width: 14px !important;
  height: 14px !important;
}
.removeAutomation:hover {
  color: #333333 !important;
}

.tagKeyword {
  margin-right: 5px;
  margin-bottom: 5px;
  padding: 3px 7px 5px 7px;
  cursor: pointer;
  display: inline-block;
  background: #fff1a8;
  border-radius: 3px;
}

.inputContain {
  border-bottom: 1px dotted #ddd;
  border-top: none;
  border-right: none;
  border-left: none;
  margin: 0 10px;
  display: inline-block;
}

.modalWrapper {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9999;
  overflow-x: hidden;
  overflow-y: scroll;
}
.modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(15, 17, 26, 0.35) none repeat scroll 0% 0%;
  z-index: 9999;
  overflow-x: hidden;
  overflow-y: scroll;
}

.shadow {
  box-shadow: 0px 0px 44px rgba(99, 99, 99, 0.85);
  border: none;
}
</style>


// WEBPACK FOOTER //
// src/components/dashboard/automationRules.vue